<ion-content fullscreen class="full-bg">
  <app-fullscreen>
    <div class="container" header>
      <app-step-header
        [hideBack]="true"
        [hideProgress]="true">
      </app-step-header>
    </div>
    <div class="container feedback" body>
      <ion-icon
        aria-hidden="true"
        class="feedback-icon secondary-icon"
        [src]="(icon || 'exlamation-point') | srcAssets: 'icons'">
      </ion-icon>
      <h1 class="feedback-title" *ngIf="!!title">
        {{ title | translate }}
      </h1>
      <span class="feedback-code" *ngIf="!!techCode">
        <ion-text color="medium">{{ 'Error code: ' + (techCode | translate) }}</ion-text>
      </span>
      <p class="feedback-message" *ngIf="!!message"
        [innerHTML]="message|translate">
      </p>
      <p class="feedback-message" *ngIf="!!instructions"
        [innerHTML]="instructions|translate">
      </p>
      <div>
        <ion-button *ngFor="let btn of buttons; let index = index"
          expand="block"
          [fill]="btn.action === 'retry' ? 'outline' : 'solid'"
          color="accent"
          size="small"
          class="ion-margin-vertical"
          (click)="onButtonClick(index)">
          <ion-icon aria-hidden="true" name="chevron-back-outline" *ngIf="btn.action === 'retry'"></ion-icon>
          {{ btn.text| translate }}
          <ion-icon aria-hidden="true" name="chevron-forward-outline" *ngIf="btn.action === 'stop'"></ion-icon>
        </ion-button>
      </div>
    </div>
  </app-fullscreen>
</ion-content>
